const data = {
  id: 1,
  title: 'Listen and choose the correct answer.',
  subTitle: 'Nghe và chọn từ điền vào chỗ trống.',
  question: 'Which school does Hoa study?',
  audioUrl: 'https://cloud.softech.cloud/storage/Data/Sentences/402770fb-c298-43c8-87b0-3808a33ac1de.mp3',
  answers: [
    { id: 1, answer: 'Tay Son Primary School.', isCorrect: true },
    { id: 2, answer: 'To Hien Thanh Primary School.', isCorrect: false },
    { id: 3, answer: 'Son Tay Primary School.', isCorrect: false },
  ],
  settings: {
    answers: {
      direction: 'horizontal',
      // direction: 'vertical',
    },
  },
};

export default data;
